import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../../constants';
import cookie from 'react-cookies';
import {approveRole, showModalEditMenu, showModalPageClass, hideModalPageClass, esUrl} from '../../../functions';
import { toast } from 'react-toastify';
import Moment from 'moment';
import {updateValueInJson} from '../../../functions';
import $ from 'jquery';
import Sortable from 'sortablejs';
import SubMenu from './subMenu';
import ModalPaginas from '../../Partials/ModalPaginas';


export default class ListadoMenu extends Component {

    constructor(props) {

        super(props);

        this.state = {
            resource: [],
            resourceEdit: {
                menu_Id:"",
                menu_Nombre:"",
                menu_Enlace: "",
                menu_Externo: false,
                menu_Superior: 0,
                subMenus: []
            },
            Validacion:{
                menu_Enlace: {
                    Error: false,
                },
                menu_Nombre: {
                    Error: false,
                }
            },
            nuevosSubmenus: 0,
            response: [],
            error: [],
            security: cookie.load('user'),
            roles: [],
            order_menu: ''
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.getResponse = this.getResponse.bind(this);
      }

    getResponse = (urlSeleccionada) => {
       let resourceEdit = this.state.resourceEdit;
       resourceEdit.menu_Enlace = urlSeleccionada;

       this.setState({resourceEdit:resourceEdit});

       hideModalPageClass("menuMain");
     }


    render() {

        let menuEdit = this.state.resourceEdit;

        return (
            <div>
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de configuración general
                        </a >
                        <Link to="/administradores">
                            &nbsp;/ Administradores
                        </Link>
                        <span> / Menú Principal</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Menú Principal
                </div>
                <div className="divMenu_Panel" id="divMenu_Panel">
                    {
                        //cards
                        (this.state.response.statusCode===200) ?
                        this.state.resource.map((resource, index) => (
                            <div className="divModuloMenu" data-idmenu={resource.menu_Id} key={"Lista_Menu_" + resource.menu_Id}>
                                <div className="lblTituloModuloMenu">
                                    {resource.menu_Nombre}
                                </div>
                                <div className="btnModuloMenu">
                                    <a href="#" className={(resource.menu_Activo ? "btnPageModuloVer" : "btnPageModuloInactivo")+" "} onClick={(event) => this.actualizarEstado(resource)}/>
                                    <a href className="btnPageModuloEditar EditarMenu" onClick={(event) => this.loadModal(resource.menu_Id)}/>
                                    <a href="#" className="btnPageModuloMover" />
                                </div>
                            </div>
                        ))
                        : null
                    }
                    <input type="hidden" value="" name="order_menu" id="txtOrdenMenu"/>
                </div>

                <div className="divContenedorBtn_Menu">
                    <Link to="/administradores">
                        VOLVER
                    </Link>
                </div>

                {/* HTML DE MODAL */}
                <div className="divInteligenciaComercial">
                    <div className="divLayerPopup_Panel">
                        <div className="divPopup_Panel">
                        <div className="divClosePopup_Panel" />
                        <h2>{menuEdit.menu_Nombre}</h2>
                        <div className="divModuloPopup_Panel">

                            {/* modal binputs */}
                            <div className="txtFile x-2">
                                <input type="text" placeholder="Nombre de Menú" value={menuEdit.menu_Nombre} onChange={this.handleInputChange} name="menu_Nombre"/>
                            </div>
                            <div className="relative x-2">
                                <span className="openLink" onClick={() => showModalPageClass("menuMain")}/>
                                <input type="text" placeholder="Enlace" value={menuEdit.menu_Enlace} onChange={this.handleInputChange} name="menu_Enlace"/>
                            </div>

                            {/* modal enlace externo */}
                            <div className="divWrapperActive">
                                <div>
                                    <span>Enlace <br />externo?</span>
                                </div>	
                                
                                <div>	
                                    <div className={this.state.resourceEdit.menu_Externo ? "containerActive backgroundPosition" : "containerActive"}
                                    onClick={() => this.checkedValidate("menu_Externo", true)}>
                                        <div className={this.state.resourceEdit.menu_Externo ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.resourceEdit.menu_Externo ? "Activado" : "Desactivado"}</span>  
                                </div>

                            </div>

                             {/* modal btn guardar */}
                            <div className="divBtnAddPopup_Panel">
                                <a href className="btnActivo" onClick={(event) => this.callFunctionButton(event)}>GUARDAR</a>
                            </div>

                            {
                                //listado de paginas
                                menuEdit.subMenus != null ?
                                menuEdit.subMenus.map((submenu, index) => (
                                    <SubMenu 
                                        admSubMenu={submenu} 
                                        key={index + "_" + submenu.menu_Id} 
                                        keyMenu={index + "_" + submenu.menu_Id}
                                    />
                                )) : null
                            }

                            {this.loadComponenteAdd(menuEdit.menu_Id)}

                        </div>
                        <div className="divBtnPopup_Panel">
                            <a href="" className="btnActivo" onClick={(event) => this.agregarSubmenu(menuEdit.menu_Id, event)}>AGREGAR</a>
                            <a href="" className="volverModal">VOLVER</a>
                        </div>
                        </div>
                    </div>
                </div>

                <ModalPaginas class={"menuMain"} callback={this.getResponse.bind(this)}/>

                {/* FIN DE HTML DE MODAL */}

            </div>
        )
    }

    checkedValidate = (item) => {

        let resource = this.state.resourceEdit;
        resource[item] = !resource[item];

        this.setState({resourceEdit:resource});
        
    }

    callFunctionButton = (event) => {

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.menu_Nombre == '') {

            newState.Validacion.menu_Nombre = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.menu_Enlace == '' || !esUrl(newState.resourceEdit.menu_Enlace)) 
		{
            newState.Validacion.menu_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}MenuUX/`;
            var dataForm = this.state.resourceEdit;
            dataForm = updateValueInJson(dataForm,'menu_UsuarioEdicion', this.state.security.nUsuCodigo);

            const formData = JSON.stringify(dataForm);

            axios.put(
            url,
            JSON.stringify(formData),
            { headers: {
            'Content-Type': 'application/json; charset=UTF-8' ,
            'Accept': 'application/json'
            }
            }
            ).then(
            (data)=> {
                if (data.data.isSucess)
                {
                    let stateResponse = this.state;

                    stateResponse.added = true;
                    this.setState(stateResponse);

                    setTimeout(() => {
                        this.setState({added:false});
                    }, 5000);
					toast.success('Se actualizó correctamente');

                }
				else
                {
                    this.setState({hasErrorProceso:true});

                    setTimeout(() => {
                        this.setState({hasErrorProceso:false});
                    }, 3000);

					console.log('Error, no se pudo actualizar.');
                }
            }
            ).catch((error)=> {
            console.log('Error no controlado.');
            this.setState({loading:false});
            });

    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,
        }

        this.setState({
            resourceEdit: copyResource,
            Validacion: validaciones,
            hasError:false
        });
    }

    loadComponenteAdd = (menu_Id) => {
        var indents = [];

        for (var i = 0; i < this.state.nuevosSubmenus; i++) {
            indents.push(<SubMenu admSubMenu={{menu_Superior:menu_Id, menu_Eliminado:0}} key={i + "_NuevoSub_" + menu_Id}/>);
        }


        return indents;
    }

    agregarSubmenu = (menu_id, e) => {
        e.preventDefault();
        let newState = this.state;
        newState.nuevosSubmenus ++;

        this.setState(newState);
    }

   loadModal = (menu_id) => {

        const url = `${API_URL}MenuUX/Seleccionar/${menu_id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            let resourceEdit = data.result;
            this.setState({resourceEdit: resourceEdit, nuevosSubmenus:0});
        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });

        showModalEditMenu();

   }

    actualizarEstado = (entity) => {

        const url = `${API_URL}MenuUX/`;
        entity.menu_Activo = !entity.menu_Activo;
        let dataToSave = updateValueInJson(entity, 'menu_UsuarioEdicion', this.state.security.nUsuCodigo);
        const formData = JSON.stringify(dataToSave);

        axios.put(
            url,
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {

                }
            ).catch((error)=> {
                console.log('Error no controlado.');
                this.setState({loading:false});
            });
    }


    componentDidMount(){

        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        var roles = this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; });
        var flag = approveRole(roles);
        //var estados= (flag?('A,R'):('B'));
        var usuario = (flag?(0):(this.state.security.nUsuCodigo));

        const url = `${API_URL}MenuUX/Listado`;
        axios.get(url).then(response => response.data)
        .then((data) => {

            this.setState({ resource: data.result, response: data, error: data.Error, roles : roles, pagina: 1 });

            Sortable.create(document.getElementById('divMenu_Panel'), {
                handle: "a.btnPageModuloMover" ,
                revert: true,
                connectToSortable: ".divMenu_Panel" ,
                update: function()
                {
                    this.OrdenarMenu();
                },
                store: {
                    get: function (sortable) {
                        let _OrdenId = "";
                        $(".divModuloMenu").each(function(index)
                        {
                            _OrdenId += $(this).data("idmenu")+"|"+(index+1)+",";
                        });
                        $("#txtOrdenMenu").val(_OrdenId);
                        return ;
                    },
                    set: function (sortable) {

                        let _OrdenId = "";
                        $(".divModuloMenu").each(function(index)
                        {
                            _OrdenId += $(this).data("idmenu")+"|"+(index+1)+",";
                        });
                        $("#txtOrdenMenu").val(_OrdenId);

                        const urlOrden = `${API_URL}MenuUX/Ordenar/${_OrdenId}`;
                        axios.get(urlOrden).then(response => response.data)
                        .then((data) => {

                            this.setState({ resource: data.result, response: data, error: data.Error, roles : roles, pagina: 1 });

                        })
                        .catch(error => {
                        });
						toast.success('Se guardó');
                    }
                }
            });

            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

}
